/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Field_Base_UrlInputs */



/**
* | output |
* | --- |
* | "API base URL" |
*
* @param {External_Apis_Field_Base_UrlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_field_base_url = /** @type {((inputs?: External_Apis_Field_Base_UrlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Field_Base_UrlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-Basis-URL")
	return /** @type {LocalizedString} */ ("API base URL")
});